export function formatPrice(value?: number): string {
  if (value == null || !Number.isFinite(value)) return '—';
  return value >= 1000 ? value.toFixed(2) : value.toFixed(value < 10 ? 3 : 2);
}

export function formatPercent(value?: number): string {
  if (value == null || !Number.isFinite(value)) return '—';
  return `${value >= 0 ? '+' : ''}${value.toFixed(2)}%`;
}

export function formatCompact(value?: number): string {
  if (value == null || !Number.isFinite(value)) return '—';
  return Intl.NumberFormat('en-US', { notation: 'compact', maximumFractionDigits: 1 }).format(value);
}
